(ns manage.resource.template
  (:require [camel-snake-kebab.core :as csk]
            [camel-snake-kebab.extras :as cske]
            [common.db.effects.http :refer [jsonify]]
            [common.url :as url]
            [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(defn get-latest-revision
  [template]
  (apply max-key :version (:revisions template)))

(defn get-request-params-template-audit
  ([advertiser-id] (get-request-params-template-audit advertiser-id nil nil nil))
  ([advertiser-id page search sort-direction]
   (cond-> {:advertiser-id advertiser-id
            :embed (jsonify ["revisions"])}
     page (merge {:page (+ 1 (/ page 10))
                  :pagesize 10})
     sort-direction (merge {:sort
                            (str (when (= (:direction sort-direction) :desc) "-")
                                 (name (:column sort-direction)))})
     (seq (:term search)) (merge {:filters
                                  (jsonify [["has"
                                             (:column search)
                                             (:term search)]])}))))

(defn response->manage-api-format
  "Transforms the response data's keys into camelCased format,
   as used by the python manage-api, except for the keys in the placeholders."
  [response]
  (letfn [(transform-data [data] (mapv transform-template data))
          (transform-revision [revision] (merge (cske/transform-keys csk/->camelCase revision)
                                                (select-keys revision [:placeholders])))
          (transform-template [template] (merge (cske/transform-keys csk/->camelCase template)
                                                {:revisions (->> template :revisions (mapv transform-revision))}))]
    (if (map? response)
      (-> (cske/transform-keys csk/->camelCase response)
          (assoc :data (transform-data (:data response))))
      (transform-data response))))

(rf/reg-event-fx :resource.template/get-all
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [db config context] :as cofx}]
    {:db (assoc db :resource.template/all {:state :pending :value []})
     :http
     {:method :get
      :uri (url/parts->str [(:apiUrl config) "advertiser-api/v1/templates"])
      :params (get-request-params-template-audit (:advertiser-id context))
      :headers {"Authorization" (:resource.user/token cofx)}
      :on-success [:resource.template/get-all-success]
      :on-failure [:resource.template/get-all-failure]}}))

(rf/reg-event-fx :resource.template/get-all-success
  (fn [{:keys [db]} [_ response-data]]
    (let [response-data (response->manage-api-format response-data)
          templates (:data response-data)
          templatesResult (mapv #(assoc % :latestRevision (get-latest-revision %))
                                templates)]
      {:db (assoc db :resource.template/all {:state :success
                                             :value templatesResult})})))

(rf/reg-event-db :resource.template/get-all-failure
  (fn [db [_ _]]
    (assoc db :resource.template/all {:state :failure :value []})))

(rf/reg-sub :resource.template/all
  (fn [db]
    (:resource.template/all db)))

(rf/reg-sub :resource.template/one
  (fn [db]
    (:resource.template/one db)))

(rf/reg-event-fx :resource.template/upgrade-hints
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context db] :resource.user/keys [token]}]
    {:db (assoc db :resource.template/upgrade-hints {:state :pending :value nil})
     :http
     {:method :get
      :uri (url-tpl/render :api/template-upgrade-hints url-context)
      :headers {"Authorization" token}
      :on-success [:resource.template/upgrade-hints-success]
      :on-failure [:resource.template/upgrade-hints-failure]}}))

(rf/reg-event-db :resource.template/upgrade-hints-success
  (fn [db [_ hints]]
    (assoc db :resource.template/upgrade-hints {:state :success
                                                :value hints})))

(rf/reg-event-db :resource.template/upgrade-hints-failure
  (fn [db _]
    (assoc db :resource.template/upgrade-hints {:state :failure})))

(rf/reg-sub :resource.template/upgrade-hints
  (fn [db _]
    (:resource.template/upgrade-hints db)))

(rf/reg-sub :resource.template/placeholder-name->placeholder-type
  :<- [:resource.template/upgrade-hints]
  (fn [upgrade-hints _]
    (->> (:value upgrade-hints)
         ;; Get all the placeholders from the current revision of each template.
         (mapcat (comp :placeholders :currentRevision))
         ;; Extract the placeholder-name->placeholder-type relation
         (map (fn [[placeholder-id placeholder-data]]
                [(name placeholder-id) (:type placeholder-data)]))
         (into {}))))
